import { createContext, useContext } from "react";
import { useIssueCountsState, type IssueCountsValue } from "./useIssueCountsState";

export { ISSUE_COUNT_PATHS } from "./useIssueCountsState";

const IssueCountsContext = createContext<IssueCountsValue>({
	counts: {},
	loading: false,
	setCount: () => {},
});

export const useIssueCounts = () => useContext(IssueCountsContext);

/**
 * Provides issue counts to the React tree. The state + API fetching logic lives
 * in `useIssueCountsState`; this provider just lifts the result into Context.
 */
export const IssueCountsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const value = useIssueCountsState();
	return <IssueCountsContext.Provider value={value}>{children}</IssueCountsContext.Provider>;
};
